import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { Contact } from "./contact"
import { IContact } from "./contact.types"
import { AccountContact } from "@/api/backofficeRest/generated/model"

export type IAccountContactRaw = AccountContact

export const ContactParser: IParser<IContact, IAccountContactRaw> = {
  toDomain: (data: IAccountContactRaw) => {
    try {
      return new Contact({
        juniferContactId: data.juniferContactId,
        juniferAccountContactId: data.juniferAccountContactId,
        contactType: data.contactType,
        title: data.title ?? "",
        firstName: data.forename ?? "",
        lastName: data.surname,
        email: data.email ?? "",
        phone1: data.phone1 ?? "",
        phone2: data.phone2 ?? null,
        phone3: data.phone3 ?? null,
        juniferPrimaryContact: data.primary,
        receiveEmail: data.receiveEmail ?? null,
        receivePost: data.receivePost ?? null,
        receiveSMS: data.receiveSMS ?? null,
        billDelivery: data.billDelivery ?? "",
        dateOfBirth: data.dateOfBirth ?? "",
        address: data.address
          ? {
              address1: data.address.address1 ?? null,
              address2: data.address.address2 ?? null,
              address3: data.address.address3 ?? null,
              address4: data.address.address4 ?? null,
              address5: data.address.address5 ?? null,
              postcode: data.address.postcode,
            }
          : null,
      })
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
